import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class LoyaltyLevel extends React.Component {
  render() {
    if (this.props.level) {
      return (
              <div>
                {`${this.context.t('Your Level')}: `}
                <span className={`font-semibold uppercase ${this.textColor(this.props.level)}`}>
                        {this.props.level}
                </span>
              </div>
      );
    }
    return null;
  }

  textColor = (txtColor) => {
    if (txtColor.includes('Gold')) {
      return 'text-loyalty-gold';
    } if (txtColor.includes('Black')) {
      return 'text-loyalty-black';
    } if (txtColor.includes('Platinum')) {
      return 'text-loyalty-platinum';
    } if (txtColor.includes('Silver')) {
      return 'text-loyalty-platinum';
    }
    return 'text-loyalty-blue';
  }
}

LoyaltyLevel.contextTypes = {
  t: PropTypes.func.isRequired,
};

LoyaltyLevel.propTypes = {
  level: PropTypes.string,
};

export default connect()(LoyaltyLevel);
